var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{key:_vm.getId,ref:"component",tag:"component",attrs:{"section-info":_vm.sectionInfo,"thumbnail-info":_vm.getThumbnailInfo(),"multisection-index":_vm.multisectionIndex}})
}
var staticRenderFns = []

export { render, staticRenderFns }